import { useState } from 'react';

import { Grid, useTheme } from '@simplywallst/ui-core';

import ActionSheet, {
  Sheet,
  Background,
  Header,
} from '@/components/ActionSheet';

import { Iframe } from './styled';

type Props = {
  onClose?(): void;
  src: string;
  iframeTitle: string;
};

export const LearningHubActionSheet = ({
  onClose,
  iframeTitle,
  src,
}: Props) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  return (
    <ActionSheet open={open} onClose={() => setOpen(false)} onClosed={onClose}>
      <Background />
      <Sheet
        sheetLayout={{
          'max-width': '1086px',
          left: 'max(0px, calc(50vw - 543px))',
        }}
      >
        <Grid templateRows={`calc(40px + ${theme.safeAreaInsetTop}) auto`}>
          <Grid
            borderTopLeftRadius="x2"
            borderTopRightRadius="x2"
            backgroundColor="white"
            templateRows="max-content auto"
            row="2"
          >
            <Header buttonStyleType="passiveReverse" />
            <Iframe
              data-cy-id="learning-hub"
              src={src}
              title={iframeTitle}
              width="100%"
              height="100%"
            />
          </Grid>
        </Grid>
      </Sheet>
    </ActionSheet>
  );
};
